import { CreateWorker } from "@pdfking/compatibility"

import type { MessageRouter } from "../types/MessageRouter"

import { WorkerForward } from "../recipies/WorkerForward"
import { RoundRobin } from "../routing/RoundRobin"

export const WorkerPool = <T, R>(
  path: URL,
  size: number = 1,
  forward?: MessageRouter<T, R>
): MessageRouter<T, R> => {
  const dispatch: MessageRouter<T, R> = request => outgoing(request)
  const workers = Array.from({ length: size }, () =>
    WorkerForward<T, R>(CreateWorker(path), dispatch)
  )
  const router = RoundRobin(workers)
  const outgoing = forward ?? router
  return router
}
